import styled, { css } from 'styled-components'

export const StyledCardHeader = styled.div`
	padding: 0 10px;
	height: 36px;
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 3px;
	background-color: ${props => props.theme.primaryColor};
	.header-delete {
		margin-right: 5px;
		cursor: pointer;
		circle {
			fill: transparent;
		}
	}
`

export const StyledCardBody = styled.div`
	padding: 12px 0;
	background-color: ${props => props.styleInverted ? '#f4f4f4' : '#fff'};
	color: ${props => !props.children ? '#afafaf' : 'unset'};
	overflow-y: auto;
	border-radius: 3px;
	box-shadow: 0 1px 2px 0 rgba(90, 90, 90, 0.12);
	${props => props.styleInverted && css`
		${CardItem} {
			:nth-child(odd) {
				background-color: #fff;
			}
			:nth-child(even) {
				background-color: rgba(255, 255, 255, 0.5);
			}
		}`
}`

export const CardItem = styled.div`
	:nth-child(even) {
		background-color: rgba(238, 238, 238, 0.5);
	}
	circle {
    fill: transparent;
	}
	svg {
		visibility: hidden;
	}
	&:hover {
		svg {
			visibility: visible;
		}
	}
	svg:hover {
		cursor: pointer;
		g, circle { stroke: ${props => props.theme.primaryColor}; }
		g { stroke-width: 0.2px; }
	}
	min-height: 36px;
	display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
`
